import { Route, Routes } from "react-router-dom";
import Layout from "../pages/layout/Layout";
import Home from "../pages/home";
import Record from "../pages/records";
import Dashboard from "../pages/dashboard";
import Settings from "../pages/settings";
import Login from "../pages/login";
import Logout from "../pages/logout";
import Cron from "../pages/cron";
import Trash from "./trash";
import Users from "./users";
import Cookie from "universal-cookie";
import { setInfo } from "../store/features/currentSlice";
import { useDispatch } from "react-redux";

import { ProtectedRoute } from "../utils/ProtectedRoutes";
import { useState } from "react";
import Reset from "./reset";

import { userSessionSchema } from "../class/user.schema";

export default function PageRoute() {
  const dispatch = useDispatch();
  const [sessionCookie, setSessionCookie] = useState<any>();
  const uCookieClass = new Cookie("session", { path: "/" });
  uCookieClass.addChangeListener((evt) => {
    if (!evt || !evt?.value) {
      return;
    }

    const parseResult = userSessionSchema.safeParse(evt.value);
    if (parseResult.success) {
      setSessionCookie(parseResult.data);
      dispatch(setInfo(parseResult.data));
    } else {
      console.error(`Unable to load session cookie!`);
    }
  });

  const removeCookieFunc = () => {
    uCookieClass.remove(`session`);
  };
  return (
    <Routes>
      <Route path="reset" element={<Reset />} />
      <Route path="login" element={<Login />} />
      <Route
        path="logout"
        element={<Logout removeCookieFunc={removeCookieFunc} />}
      />
      <Route element={<Layout sessionCookie={sessionCookie} />}>
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Home />
            </ProtectedRoute>
          }
        />
        <Route
          path="/home"
          element={
            <ProtectedRoute>
              <Home />
            </ProtectedRoute>
          }
        />
        <Route
          path="/records"
          element={
            <ProtectedRoute>
              <Record />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/users"
          element={
            <ProtectedRoute adminOnly>
              <Users />
            </ProtectedRoute>
          }
        />
        <Route
          path="/trash"
          element={
            <ProtectedRoute adminOnly>
              <Trash />
            </ProtectedRoute>
          }
        />
        <Route
          path="/settings"
          element={
            <ProtectedRoute>
              <Settings />
            </ProtectedRoute>
          }
        />
        <Route
          path="/cron"
          element={
            <ProtectedRoute adminOnly>
              <Cron />
            </ProtectedRoute>
          }
        />
      </Route>
    </Routes>
  );
}
